const actions = {
  CHECK_AUTHORIZATION: "CHECK_AUTHORIZATION",

  CAT_LIST: "CAT_LIST",
  CAT_LIST_RESULT: "CAT_LIST_RESULT",
  CAT_FETCH_ID: "CAT_FETCH_ID",
  CAT_FETCH_LIST_ID: "CAT_FETCH_LIST_ID",
  CAT_EDIT_BY_MGC: "CAT_EDIT_BY_MGC",
  CAT_NUT_EDIT_BY_ID: "CAT_NUT_EDIT_BY_ID",
  CAT_LEAF_ADD: "CAT_LEAF_ADD",
  CAT_LEAF_DELETE: "CAT_LEAF_DELETE",
  COLOR_GET_DIABETES: "COLOR_GET_DIABETES",
  COLOR_SET_DIABETES: "COLOR_SET_DIABETES",
  COLOR_GET_TLL: "COLOR_GET_TLL",
  COLOR_SET_TLL: "COLOR_SET_TLL",

  leafCatAdd: (history, dataObj) => ({
    //Action creator function
    type: actions.CAT_LEAF_ADD, //Action
    payload: { history, dataObj }, //pass payload to action, we should pass as little data to action
  }),

  leafDelete: (history, dataObj) => ({
    //Action creator function
    type: actions.CAT_LEAF_DELETE, //Action
    payload: { history, dataObj }, //pass payload to action, we should pass as little data to action
  }),

  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),

  CatRead: (info) => ({
    type: actions.CAT_LIST,
    payload: { info, page: 1 },
  }),
  catEditBYMgc: (history, info, id) => ({
    type: actions.CAT_EDIT_BY_MGC,
    payload: { history, info, id },
  }),
  onPageChange: (info, page) => ({
    type: actions.CAT_LIST,
    payload: { info, page },
  }),
  catListSuccess: (exportresult, result, success, total_count, page) => ({
    type: actions.CAT_LIST_RESULT,
    exportresult,
    result,
    success,
    total_count,
    page,
  }),
  catfetchBYId: (listid) => ({
    type: actions.CAT_FETCH_ID,
    payload: { listid },
  }),
  catListById: (result, success, countryNpxInfo) => ({
    type: actions.CAT_FETCH_LIST_ID,
    result,
    success,
    countryNpxInfo,
  }),
  catNutEditBYId: (history, info, id) => ({
    type: actions.CAT_NUT_EDIT_BY_ID,
    payload: { history, info, id },
  }),
   /** For TLL */
  TLLColorGet: (info) => ({
    type: actions.COLOR_GET_TLL,
    payload: { info },
  }),
  TLLColorSet: (TLLResult, success) => ({
    type: actions.COLOR_SET_TLL,
    TLLResult,
    success,
  }),
  /** For Diabteste */
  diabteseColorGet: (info) => ({
    type: actions.COLOR_GET_DIABETES,
    payload: { info },
  }),
  diabteseColorSet: (diabteseResult, success) => ({
    type: actions.COLOR_SET_DIABETES,
    diabteseResult,
    success,
  }),
 
  
};
export default actions;
